<template>
    <div class="form-group">
        <label class="amo-settings-label" :for="id || label" v-if="label">
            {{ label.charAt(0).toUpperCase() + label.slice(1) }}
        </label>
        <div class="select-input-wrapper">
            <select
                class="form-control select-input"
                :id="id || undefined"
                :class="{ 'input-error': error }"
                :value="modelValue"
                :required="required"
                :disabled="disabled"
                @change="$emit('update:modelValue', $event.target.value)"
            >
                <option :value="''" disabled>{{ placeholder }}</option>
                <option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item[valueKey]"
                >
                    {{ item[labelKey] }}
                </option>
            </select>
            <span class="select-caret" aria-hidden="true"></span>
        </div>
        <span v-if="error" class="error-text">
            {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: [String, Number],
        id: String,
        label: String,
        options: {
            type: Array,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        valueKey: {
            type: String,
            default: "value",
        },
        labelKey: {
            type: String,
            default: "label",
        },
        placeholder: {
            type: String,
            default: "Select an option",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error: String,
    },
};
</script>

<style scoped>
.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #555;
    text-align: left;
}

.flat-input {
    width: 100%;
    padding: 12px;
    border: none;
    background: #f9f9ff;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: 0.3s;
}
.flat-input:focus {
    background: #eefbf1;
}
.select-input-wrapper {
    position: relative;
}
.select-input {
    padding-right: 44px;
}
.select-caret {
    position: absolute;
    top: 50%;
    right: 18px;
    width: 10px;
    height: 10px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    color: #6f685d;
    pointer-events: none;
    transform: translateY(-70%) rotate(45deg);
}
.select-input:disabled + .select-caret {
    opacity: 0.55;
}
.input-error {
    border: 1px solid #dc3545;
    background-color: #fff6f6;
}
.input-error {
    border: 1px solid #dc3545;
    background-color: #fff6f6;
}
.error-text {
    color: red;
    font-size: 14px;
    margin-top: 5px;
    display: block;
}
</style>
